type Listener = () => void;

let smtpPanelOpen = false;
const listeners = new Set<Listener>();

export function subscribeToSmtpPanelPersistence(listener: Listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function isSmtpPanelPersistent() {
  return smtpPanelOpen;
}

export function setSmtpPanelPersistent(open: boolean) {
  if (smtpPanelOpen === open) return;
  smtpPanelOpen = open;
  listeners.forEach(listener => listener());
}
